import request from './request'

export default {
  list(data) {
    return request.post('/banner/list', data)
  },
  info(data) {
    return request.post('/banner/info', data)
  },
  save(data) {
    return request.post('/banner/save', data)
  },
  enable(data) {
    return request.post('/banner/enable', data)
  },
  disable(data) {
    return request.post('/banner/disable', data)
  },
  delete(data) {
    return request.post('/banner/delete', data)
  },
}
